import { gql } from '@apollo/client';

export const DELETE_BLOG_POST_MUTATION = gql`
  mutation DeleteBlogPost($id: ID!) {
    deleteBlogPost(input: { where: { id: $id } }) {
      blogPost {
        id
      }
    }
  }
`;
